// extracted by mini-css-extract-plugin
export var container = "index-module--container--WONci";
export var darkContainer = "index-module--darkContainer--udy5P";
export var iframeContainer = "index-module--iframeContainer--W1YRj";
export var textContainer = "index-module--textContainer--D44LO";